import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";

const firebaseBapp = initializeApp({
   apiKey: "AIzaSyCwN78OBFb_BF4rTg9kwde2XNQ4ARzzdTA",
   authDomain: "adakchoob-773f2.firebaseapp.com",
   projectId: "adakchoob-773f2",
   storageBucket: "adakchoob-773f2.appspot.com",
   messagingSenderId: "228400070688",
   appId: "1:228400070688:web:8653f5a21a0aa46841bc45",
});

let messaging;
try {
   messaging = getMessaging(firebaseBapp);
} catch (ex) {
   console.log("This browser doesn't support the API's required to use the Firebase SDK. (messaging/unsupported-browser).");
}
// Retrieve firebase messaging

export const checkFirebaseToken = async () => {
   // if (navigator.userAgent.match(/iphone|mac/gim)) {
   //    return;
   // }
   let firebaseToken = localStorage.getItem("listenerId");
   console.log(firebaseToken);
   if (!firebaseToken) {
      let token = await requestForToken();
      if (token) {
         return token;
      } else {
         console.log("cannot get firebase token!");
      }
   }
   return firebaseToken;
};

export const deleteFirebaseTokenFromBrowser = async () => {
   if (messaging) {
      let result = await deleteToken(messaging);
   }
};

export const requestForToken = async () => {
   if (messaging) {
      try {
         let data = await getToken(messaging, {
            vapidKey: "BA7zzctXI-OTrYA2KWXXn4y02NpEEohxrkJ5cKaRZWXUh17S5WN4iqe3cm0F9WSzqi-_XByl2NZgLJQSCeQZjts",
         });
         return data;
      } catch (ex) {
         console.log("Vap Exception: ", ex?.message);
      }
   }
};

onMessage(messaging, (payload) => {
   const receiveNotification = new CustomEvent("onReceiveNotification", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: { ...payload?.data },
   });

   window.dispatchEvent(receiveNotification);
});

/* eslint-disable no-restricted-globals */
